var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatusStampSpecialOrange = function SvgStatusStampSpecialOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.85
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0018 6.26159C34.6818 2.22686 29.7706 0 24.1862 0L24.1785 0C13.048 0 2.35346 9.16349 0.341551 20.4297C-0.68353 26.187 0.616945 31.6261 3.99818 35.7384C7.31822 39.7731 12.2294 42 17.8138 42H17.8215C28.952 42 39.6465 32.8365 41.6584 21.5703C42.6835 15.813 41.3831 10.3817 38.0018 6.26159ZM31.7289 20.5926C30.6197 26.7922 24.7599 31.8433 18.663 31.8433C15.9243 31.8433 13.5529 30.7959 11.9923 28.8949C10.3782 26.9396 9.77383 24.2782 10.2864 21.4151C11.3956 15.2156 17.2554 10.1644 23.3523 10.1644C26.091 10.1644 28.4624 11.2119 30.023 13.1129C31.6371 15.0682 32.2415 17.7295 31.7289 20.5926Z",
    fill: "url(#paint0_linear_510_3528)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9124 11.8093L25.6625 14.5405L24.8593 3.95712C24.7981 3.16569 23.6965 3.17345 23.3522 3.95712L18.7623 14.6259L13.2851 11.7938C12.7802 11.53 12.1376 12.1895 12.413 12.6861L16.4444 20.0185L16.2761 20.4142C16.2226 20.5461 16.1843 20.678 16.1614 20.8099L9.76611 27.9327C9.32242 28.4293 9.73551 29.0811 10.3322 28.825L16.5209 26.1171L17.3854 37.5152C17.4466 38.3066 18.5481 38.2989 18.8924 37.5152L23.7807 26.1481L28.9596 28.825C29.4645 29.0888 30.1071 28.4293 29.8317 27.9327L25.9991 20.9573C26.0833 20.7323 26.1291 20.4918 26.1062 20.2667L26.0756 19.8245L32.4862 12.6861C32.9299 12.1895 32.5168 11.5378 31.9201 11.7938L31.9124 11.8093ZM24.1555 20.3211C23.8495 22.0203 22.243 23.4014 20.5677 23.4014C18.8924 23.4014 17.7755 22.0203 18.0738 20.3211C18.3798 18.6218 19.9863 17.2407 21.6616 17.2407C23.337 17.2407 24.4538 18.6218 24.1555 20.3211Z",
    fill: "#EC8247"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_510_3528",
    x1: 6.54789,
    y1: 8.31086,
    x2: 38.478,
    y2: 30.1371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FC5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52C5FF"
  })))));
};
export default SvgStatusStampSpecialOrange;